import { render, staticRenderFns } from "./SalesProductGroupsPage.vue?vue&type=template&id=459132d8&scoped=true&"
import script from "./SalesProductGroupsPage.vue?vue&type=script&lang=js&"
export * from "./SalesProductGroupsPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesProductGroupsPage.vue?vue&type=style&index=0&id=459132d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459132d8",
  null
  
)

export default component.exports